import type { BrandVariants } from '@fluentui/react-components'

export const brBrandRamp: BrandVariants = {
  10: '#1A0800',
  20: '#2E0E00',
  30: '#4A1600',
  40: '#661E00',
  50: '#852700',
  60: '#A53000',
  70: '#C03610',
  80: '#D43D14',
  90: '#E8431A',
  100: '#F05535',
  110: '#F56A4F',
  120: '#F87F6A',
  130: '#FA9585',
  140: '#FCAB9F',
  150: '#FDC2B9',
  160: '#FED9D4',
}
